import React from 'react'
import { VStack, Text, Button, Heading, Container } from '@chakra-ui/react'

import { WizardStepForm } from 'components'

export const UserRegistrationStep5 = props => (
  <WizardStepForm {...props} hideNavigation justify='center'>
    <Heading size='4xl' textAlign='center' my={5}>
      Parabéns!
    </Heading>
    <Container my={5}>
      <VStack spacing={5}>
        <Text align='center'>
          Preencheu todas os dados de utilizador, da entidade e do projeto. <br />
          Caso pretenda submeter os dados e continuar com a avaliação prima a opção "Submeter e preencher Questionário".
        </Text>
        <Button colorScheme='green' type='submit'>Submeter e preencher Questionário</Button>
      </VStack>
    </Container>
  </WizardStepForm>
)

export default UserRegistrationStep5
